module.exports = __webpack_public_path__ + "static/media/notimg4.743eb9ce.svg";